import React from 'react'
import { Dialog, DialogContent } from "@mui/material";
import ForgetPassword from '../ForgetPassword';

const ForgetPasswordModal = ({openForgetPwdDialog,setOpenForgetPwdDialog}) => {
  return (
    <Dialog
      maxWidth="sm"
      open={openForgetPwdDialog}
      onClose={() => setOpenForgetPwdDialog(false)}
      aria-labelledby="category-filter-dialog"
      PaperProps={{
        sx: {
          borderRadius: '12px',
          maxWidth: '420px',
        }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <ForgetPassword setOpenForgetPwdDialog={setOpenForgetPwdDialog}/>
      </DialogContent>
    </Dialog>
  )
}

export default ForgetPasswordModal;



